import { ApiDataAdapter } from '@safarilaw-webapp/shared/crud';

export abstract class RmsDataAdapter<T> extends ApiDataAdapter<T> {}
